import React, { useState } from 'react'
import { useToast } from '@chakra-ui/core'
import BaseModalV2 from 'components/TasksV2/UI/BaseModalV2'
import useLocaleText from 'components/useLocaleText'
import { AppDispatch } from 'config/redux'
import { ITag } from 'constants/interfaces'
import { FormContext, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { TagForm } from './TagForm'
import { createTag, updateTag } from 'redux/actions/config'
import { ModalHeader } from '../commonUI/Modal/ModalHeader'
import { ModalFooter } from '../commonUI/Modal/ModalFooter'

export const TAG_TYPE = {
  SYSTEM: 1,
  DEFAULT: 0,
}

const DEFAULT_VALUES: ITag = {
  groups: [],
  users: [],
  name: '',
  sk: '',
  isDefault: false,
  tag_color: '',
  tag_type: 0,
}

interface TagModalProps {
  isOpen: boolean
  requestCloseTagModal: () => void
  onClose: () => void
  tag?: ITag | null
}

export const TagModal: React.FC<TagModalProps> = ({ isOpen, onClose, tag, requestCloseTagModal }) => {
  const toast = useToast()
  const dispatch: AppDispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(false)
  const isEdit = !!tag

  const t_create_tag = useLocaleText('create_tag')
  const t_edit_tag = useLocaleText('edit_tag')
  const admin_submit_button = useLocaleText('admin_submit_button')
  const modal_title = isEdit ? t_edit_tag : t_create_tag

  const methods = useForm<ITag>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: tag || DEFAULT_VALUES,
  })

  const onSubmit = async (data: ITag) => {
    try {
      setIsLoading(true)
      const { groups, users, name, tag_color, tag_type } = data

      if (!isEdit) {
        const newTag = await dispatch(createTag({ name, tag_color, tag_type }))
        await dispatch(updateTag({ ...newTag, groups: groups || [], users: users || [] }))
      } else {
        await dispatch(updateTag({ ...tag, groups: groups || [], users: users || [], tag_color }))
      }
      onClose()
      toast({
        title: isEdit ? 'Tag updated' : 'Tag created',
        description: isEdit ? 'Tag updated successfully' : 'Tag created successfully',
        status: 'success',
        position: 'top-right',
      })
    } catch (error) {
      console.error('[onSubmit] Error:', error)
      toast({
        title: 'Error',
        description: 'Failed to create tag',
        status: 'error',
        position: 'top-right',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <FormContext {...methods}>
      <BaseModalV2
        isOpen={isOpen}
        onClose={onClose}
        header={<ModalHeader title={modal_title} onClose={requestCloseTagModal} />}
        body={<TagForm isLoading={isLoading} />}
        footer={<ModalFooter isLoading={isLoading} onSubmit={onSubmit} buttonText={admin_submit_button} />}
        modalContentProps={{
          w: '100%',
          maxW: { base: '90%', md: '60vw', lg: '800px' },
          minW: '350px',
          pointerEvents: isLoading ? 'none' : 'auto',
        }}
        modalBodyProps={{
          backgroundColor: 'white !important',
          opacity: isLoading ? 0.8 : 1,
          height: 'auto',
          maxH: '70vh',
        }}
        modalHeaderProps={{ boxShadow: 'none' }}
      />
    </FormContext>
  )
}
